export default IconVip => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-vip" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 5h18" />
  <path d="M3 19h18" />
  <path d="M4 9l2 6h1l2 -6" />
  <path d="M12 9v6" />
  <path d="M16 15v-6h2a2 2 0 1 1 0 4h-2" />
</svg>`;